"use client";
import { catchError } from "next/error";

const HideOnErrorBoundary = catchError(() => null);

export default HideOnErrorBoundary;
